/* Tarih format yardımcıları — sistem tekdüze GG.AA.YYYY. */

/** ISO YYYY-MM-DD veya ISO datetime → "GG.AA.YYYY" */
export function fmtDate(iso) {
  if (!iso) return "";
  const s = String(iso).trim();
  // Datetime ise sadece tarih kısmını al
  const dateOnly = s.length >= 10 ? s.slice(0, 10) : s;
  const m = dateOnly.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return s; // format tanımsız → olduğu gibi bırak
  return `${m[3]}.${m[2]}.${m[1]}`;
}

/** ISO datetime → "GG.AA.YYYY SS:DD" */
export function fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm}.${yy} ${hh}:${mi}`;
}

/** "GG.AA.YYYY" → ISO "YYYY-MM-DD" (girişte kullanıcı elle yazarsa) */
export function parseTrDate(tr) {
  if (!tr) return "";
  const m = String(tr).match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!m) return "";
  return `${m[3]}-${m[2]}-${m[1]}`;
}
